import { Helmet } from "react-helmet-async";
import { Route, Switch } from "react-router-dom";
import { ProjectPermissionProvider } from "pages/project/ProjectPermissionProvider";
import { DataTableProvider } from "pages/gdt/store/DataTableProvider";
import { ProjectFoldersProvider } from "pages/gdt/folders/ProjectFoldersProvider";
import { ModalProvider } from "providers/ModalProvider/ModalProvider";
import { PageToolProjectTabs } from "./PageToolProjectTabs";
import { useRouteMapContext } from "providers/RouteMapProvider/RouteMapProvider";
import { PageToolEditor } from "components/ToolEditor/PageToolEditor";
import { useToolDataContext } from "./ToolDataProvider";
import assert from "assert";
import { isNonNullish } from "utils/isNonNullish";

export const PageToolProject = () => {
  const { tool } = useToolDataContext();
  assert(isNonNullish(tool.project), "Expected tool project to be non-nullish");
  const project = tool.project;
  const routeMap = useRouteMapContext((s) => s.routeMap);

  return (
    <>
      <Helmet>
        <title>{`${tool.name}`}</title>
      </Helmet>
      <ProjectPermissionProvider projectId={project.id}>
        <DataTableProvider projectKey={project.key}>
          <ProjectFoldersProvider projectKey={project.key}>
            <ModalProvider>
              <Switch>
                <Route
                  path={[
                    routeMap["TOOL"].parameterizedPath,
                    routeMap["TOOL_TASKS"].parameterizedPath,
                    routeMap["TOOL_FILES"].parameterizedPath,
                    routeMap["TOOL_SETTINGS"].parameterizedPath,
                  ]}
                  exact
                >
                  <PageToolProjectTabs />
                </Route>
                <Route path={routeMap["TOOL_EDITOR"].parameterizedPath} exact>
                  <PageToolEditor />
                </Route>
              </Switch>
            </ModalProvider>
          </ProjectFoldersProvider>
        </DataTableProvider>
      </ProjectPermissionProvider>
    </>
  );
};
